import {action, makeObservable, observable} from "mobx";
import {SortOrder} from "../../../shared/enums/sortOrder";

export interface IOccasionUiStore {
  /**
   * Selected sort order for the date of occasions.
   */
  sortOrder: SortOrder;

  /**
   * Selected calendar year by the user.
   */
  calendarYear: number;

  /**
   * Update the sort order of the date of occasions.
   */
  updateSortOrder: (sortOrder: SortOrder) => void;

  /**
   * Update the calendar year selected by the user.
   */
  updateCalendarYear: (calendarYear: number) => void;
}

export class OccasionUiStore implements IOccasionUiStore {
  sortOrder: SortOrder;
  calendarYear: number;

  constructor() {
    makeObservable(this, {
      sortOrder: observable,
      calendarYear: observable,
      updateSortOrder: action,
      updateCalendarYear: action
    });

    this.sortOrder = SortOrder.Descending;
    this.calendarYear = new Date().getFullYear();
  }

  updateSortOrder = (sortOrder: SortOrder) => {
    this.sortOrder = sortOrder;
  };

  updateCalendarYear = (calendarYear: number) => {
    this.calendarYear = calendarYear;
  };
}
